import Vue from 'vue'
import Router from 'vue-router'
import ActivityIndex from "../components/ActivityIndex";
import Home from "../components/Home";
import loginPage from "../login/login";
import forget from "../login/forget";
import AdminIndex from "../components/admin/AdminIndex";
import NoticeIndex from "../components/NoticeIndex";
import VoteRules from "../components/VoteRules";
import VotePage from "../components/VotePage";
import test from "../components/test";

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/admin',
      redirect: '/admin/vote/list'
    },
    {
      path: '/home',
      name:'home',
      component: Home
    },
    {
      path: '/notice/detail/:id',
      name: 'noticeDetail',
      component: NoticeIndex
    },
    {
      path: '/',
      name: 'Home',
      component: loginPage
    },
    {
      path:'/activityIndex/:id',
      name:'ActivityIndex',
      component:ActivityIndex
    },
    {
      path:'/login/forget',
      component:forget
    },
    {
      path:'/login',
      component: loginPage
    },
    {
      path: '/admin',
      component: AdminIndex
    },
    {
      path:'/vote-rules',
      name:'VoteRules',
      component: VoteRules
    },
    {
      path:'/vote',
      name:'VotePage',
      component: VotePage
    },
    {
      path:'/test',
      component: test
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js